module.exports = __webpack_public_path__ + "static/media/Lenn Scholz_1616421278380.442db11b.jpeg";